import { createSelector } from '@reduxjs/toolkit';
import { docsForLinking } from './docsForLinking';
import type { DocForLinking } from './docForLinkingType';
import type { DocsForLinkingIndex } from './docsForLinkingIndexType';

/**
 * Indexed version of docsForLinking for O(1) lookup performance.
 *
 * This selector builds Map structures to enable fast document lookups
 * by templateId or uuid, replacing the O(n) array.find() approach.
 *
 * Expected performance improvement: 30-50% faster link conversion
 * for documents with many internal links.
 */

export const docsForLinkingById = createSelector(docsForLinking, (docs): DocsForLinkingIndex => {
  const byTemplateId = new Map<number, DocForLinking>();
  const byUuid = new Map<string, DocForLinking>();

  docs.forEach((doc) => {
    if (doc.templateId !== undefined) {
      byTemplateId.set(doc.templateId, doc);
    }
    byUuid.set(doc.uuid, doc);
  });

  return { byTemplateId, byUuid };
});
